module.exports = __webpack_public_path__ + "media/images/icon_blog_gray-b2c8d4ad905a5621e5377dd67a47138d.png";